const MIN_PROGRESS_TOTAL_TOLERANCE = 1024 * 1024;

export function analyzeUploadProgress(
  event: Pick<ProgressEvent, "lengthComputable" | "loaded" | "total">,
  expectedBytes: number,
): { percent: number | null; rejectionReason: string | null } {
  const tolerance = Math.max(
    MIN_PROGRESS_TOTAL_TOLERANCE,
    expectedBytes * 0.1,
  );
  let rejectionReason: string | null = null;

  if (!event.lengthComputable) rejectionReason = "length_not_computable";
  else if (!Number.isFinite(event.loaded) || !Number.isFinite(event.total))
    rejectionReason = "non_finite_values";
  else if (event.total <= 0) rejectionReason = "invalid_total";
  else if (event.loaded < 0 || event.loaded > event.total)
    rejectionReason = "invalid_loaded_value";
  else if (event.total < expectedBytes)
    rejectionReason = "total_smaller_than_payload";
  else if (event.total > expectedBytes + tolerance)
    rejectionReason = "total_larger_than_payload";

  return {
    percent: rejectionReason
      ? null
      : Math.min(100, (event.loaded / event.total) * 100),
    rejectionReason,
  };
}

export function getUploadProgress(
  event: Pick<ProgressEvent, "lengthComputable" | "loaded" | "total">,
  expectedBytes: number,
): number | null {
  return analyzeUploadProgress(event, expectedBytes).percent;
}
